import React from 'react';
import Helmet from 'react-helmet';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from 'actions/auth';
import UserContainer from 'components/user/container/UserContainer';
import { Language } from 'language/Language';
import { strings } from './strings';

const AccountDetails = ({ history }) => {

  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state);
  const language = Language();

  const EnString = () => (
    <p>
      {strings[language].hello}
      <strong>
        {userInfo.displayName}
      </strong>
      {strings[language].not}
      <strong>
        {userInfo.displayName}
        {'?'}
      </strong>
      <strong style={{ cursor: 'pointer' }} onClick={() => dispatch(logout(history, language === 'japan' ? '/ja/私のアカウント' : '/my-account'))}>{strings[language].logout}</strong>
      )
    </p>
  );

  const JpStrings = () => (
    <p>
      <strong>
        {userInfo.displayName}
      </strong>
      {strings.japan.hello}
      <strong>
        {userInfo.displayName}
      </strong>
      {strings.japan.not}
      <strong style={{ cursor: 'pointer' }} onClick={() => dispatch(logout())}>{strings.japan.logout}</strong>
      {strings.japan.not2}
    </p>
  );

  return (
    <>
      <Helmet title={language === 'japan' ? '私のアカウント' : 'My Account- details'} />
      <UserContainer>
        <div>
          {language === 'english'
            ? (
              <EnString />
            )
            : (
              <JpStrings />
            )}
          <p>{strings[language].info}</p>
        </div>
      </UserContainer>
    </>
  );
};

export default AccountDetails;
